import { QuestionnaireQuestions } from '@getpopsure/qnr-framework';
import * as Sentry from '@sentry/react';
import { useMutation } from '@tanstack/react-query';
import {
  Transform,
  transformQuestionnaire,
} from 'features/generalQuestionnaire/generalPolicy/actions';
import endpoint from 'shared/api';

export const usePersistQnrAndQuote = () => {
  const mutation = useMutation({
    mutationFn: async ({
      insuranceType,
      questionnaireAnswers,
      metas,
      transform,
    }: {
      insuranceType: string;
      questionnaireAnswers: QuestionnaireQuestions;
      transform?: Transform;
      metas: Record<string, unknown>;
    }): Promise<{ quoteId: string; questionnaireId: string }> => {
      const answers = transform
        ? transformQuestionnaire(transform, questionnaireAnswers)
        : questionnaireAnswers;

      const {
        data: { quoteId, questionnaireId },
      } = await endpoint.network.post<{
        quoteId: string;
        questionnaireId: string;
      }>('/signups/pre-checkout', {
        questionnaire: {
          answers,
          questionnaireType: insuranceType,
          metas,
        },
        quote: {
          insuranceType,
          answers: questionnaireAnswers,
        },
      });

      return { quoteId, questionnaireId };
    },
    onError: (error, { insuranceType, questionnaireAnswers }) => {
      Sentry.captureException(error, {
        tags: {
          feature: 'ADJUST_POLICY',
        },
        extra: {
          insuranceType,
          questionnaireAnswers,
          description: `An error occurred while trying to persist a new questionnaire and quote for adjusting a policy`,
        },
      });
    },
  });

  return mutation;
};
